import {StyleSheet} from 'react-native';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';

export const styles = StyleSheet.create({
  section: {
    marginVertical: vs(16),
    paddingHorizontal: vs(12),
  },
  sectionHeader: {
    fontSize: FontSizes[16],
    fontWeight: 'bold',
    color: '#4D3F37',
    marginBottom: vs(8),
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  input: {
    flex: 1,
    marginHorizontal: vs(8),
    marginVertical: vs(8),
    minWidth: vs(140),
  },
  errorText: {
    color: 'red',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  successText: {
    color: 'green',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  buttonContainer: {
    alignItems: 'center',
    marginVertical: vs(16),
  },
  tabContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Tab styles
  tabContainer: {
    marginVertical: vs(16),
    paddingHorizontal: vs(12),
    borderBottomWidth: 1,
    borderBottomColor: CCColors.BorderBottom,
    paddingBottom: vs(12),
  },
  tabButton: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
